import languageHelpers from "./languageHelpers";

const dateHelpers = {
    month: m => {
        const months = ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"];
        return months[m];
    },

    day: (date, d, lang) => {
        let content = languageHelpers.getTranslation(lang).dates;
        if (dateHelpers.isToday(date)) return content.today;
        if (dateHelpers.isTomorrow(date)) return content.tomorrow;

        const days = content.daysOfWeek;
        return days[d];
    },

    getNextDay: date => {
        let nextDay = new Date(new Date(date).setDate(new Date(date).getDate() + 1));
        return `${nextDay.getMonth() + 1}/${nextDay.getDate()}/${nextDay.getFullYear()}`;
    },

    isToday: d => {
        const today = new Date();
        return d.getDate() == today.getDate() &&
            d.getMonth() == today.getMonth() &&
            d.getFullYear() == today.getFullYear()
    },

    isTomorrow: d => {
        const tomorrow = new Date();
        tomorrow.setDate(new Date().getDate() + 1);
        return d.getDate() == tomorrow.getDate() &&
            d.getMonth() == tomorrow.getMonth() &&
            d.getFullYear() == tomorrow.getFullYear()
    },

    addDays: (days, date) => {
        if (!date) date = new Date(new Date());
        date.setDate(date.getDate() + days);
        return date;
    },

    getSuffix: day => {
        let lastNumber = day % 10;
        if (lastNumber === 1) {
            return "st";
        }
        if (lastNumber === 2) {
            return "nd";
        }
        return "th"
    },

    getAppointmentDay: (date, lang) => {
        let today = date || new Date();
        return `${dateHelpers.day(today, today.getDay(), lang)}, ${dateHelpers.month(today.getMonth())} ${today.getDate()}${dateHelpers.getSuffix(today.getDate())}`
    },

    getScheduleDay: (date, lang) => {
        let today = date || new Date();
        return `${dateHelpers.day(today, today.getDay(), lang)}, ${dateHelpers.month(today.getMonth())} ${today.getDate()}${lang === "ja" ? "日" : ""}`
    },

    getTimeZoneOffset: () => {
        return new Date().getTimezoneOffset() / -60;
    },

    getDayOfTheWeek: day => {
        const days = ["Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"];
        return days[day.getDay()]
    },

    getTimeString: (date, includeAmPm) => {
        let hours = date.getHours();
        let minutes = date.getMinutes();
        let time = `${hours === 0 ? 12 : hours > 12 ? hours - 12 : hours}:${minutes < 10 ? "0" : ""}${minutes}`
        if (includeAmPm) {
            time = `${time} ${hours >= 12 ? "PM" : "AM"}`;
        }
        return time;
    }
}

export default dateHelpers;